"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.managementRoutes = void 0;
const component_1 = require("@front/pages/company/form/component");
const component_2 = require("@front/pages/company/list-gate/component");
const component_3 = require("@front/pages/company/preview/component");
const component_4 = require("@front/pages/user/form/component");
const component_5 = require("@front/pages/user/list/component");
const component_6 = require("@front/pages/user-group/form/component");
const component_7 = require("@front/pages/user-group/list/component");
const component_8 = require("@front/pages/branch/form/component");
const component_9 = require("@front/pages/branch/list/component");
const component_10 = require("@front/pages/profession/form/component");
const component_11 = require("@front/pages/profession/list/component");
const component_12 = require("@front/pages/step/form/component");
const component_13 = require("@front/pages/step/list/component");
const backendImport_1 = require("@front/backendImport");
const { aclResources, aclActions } = backendImport_1.ACL;
exports.managementRoutes = [
    {
        path: '/company/list',
        name: 'route.company.list'.t(),
        component: component_2.CompanyListGate,
        icon: 'briefcase',
        inMenu: true,
        acl: `${aclResources.company}.${aclActions.read}`
    },
    {
        path: '/company/preview/:id',
        name: 'route.company.preview'.t(),
        component: component_3.CompanyPreview,
        forceActive: '/company/list',
        inMenu: false,
        acl: `${aclResources.company}.${aclActions.read}`
    },
    {
        path: '/company/preview',
        name: 'route.company.preview'.t(),
        component: component_3.CompanyPreview,
        forceActive: '/company/list',
        inMenu: false,
        acl: `${aclResources.company}.${aclActions.read}`
    },
    {
        path: '/company/create',
        name: 'route.company.create'.t(),
        component: component_1.CompanyForm,
        forceActive: '/company/list',
        inMenu: false,
        acl: `${aclResources.company}.${aclActions.write}`
    },
    {
        path: '/company/edit/:id',
        name: 'route.company.edit'.t(),
        component: component_1.CompanyForm,
        forceActive: '/company/list',
        inMenu: false,
        acl: `${aclResources.company}.${aclActions.write}`
    },
    {
        path: '/user/list/:q',
        name: 'route.user.list'.t(),
        component: component_5.UserList,
        inMenu: false,
    },
    {
        path: '/user/list',
        name: 'route.user.list'.t(),
        component: component_5.UserList,
        icon: 'user',
        inMenu: true,
    },
    {
        path: '/user/create',
        name: 'route.user.create'.t(),
        component: component_4.UserForm,
        forceActive: '/user/list',
        inMenu: false,
    },
    {
        path: '/user/edit/:id',
        name: 'route.user.edit'.t(),
        component: component_4.UserForm,
        forceActive: '/user/list',
        inMenu: false,
    },
    {
        path: '/user-group/list',
        name: 'route.userGroup.list'.t(),
        component: component_7.UserGroupList,
        icon: 'people',
        inMenu: true,
        acl: `${aclResources.settings_access}.${aclActions.read}`
    },
    {
        path: '/user-group/create',
        name: 'route.userGroup.create'.t(),
        component: component_6.UserGroupForm,
        forceActive: '/user-group/list',
        inMenu: false,
        acl: `${aclResources.settings_access}.${aclActions.write}`
    },
    {
        path: '/user-group/edit/:id',
        name: 'route.userGroup.edit'.t(),
        component: component_6.UserGroupForm,
        forceActive: '/user-group/list',
        inMenu: false,
        acl: `${aclResources.settings_access}.${aclActions.write}`
    },
    {
        path: '/branch/list',
        name: 'route.branch.list'.t(),
        component: component_9.BranchList,
        inMenu: true,
        acl: `${aclResources.onboarding}.${aclActions.read}`
    },
    {
        path: '/branch/form',
        name: 'route.branch.create'.t(),
        component: component_8.BranchForm,
        forceActive: '/branch/list',
        inMenu: false,
        acl: `${aclResources.onboarding}.${aclActions.write}`
    },
    {
        path: '/branch/form/:id',
        name: 'route.branch.edit'.t(),
        component: component_8.BranchForm,
        forceActive: '/branch/list',
        inMenu: false,
        acl: `${aclResources.onboarding}.${aclActions.write}`
    },
    {
        path: '/profession/list',
        name: 'route.profession.list'.t(),
        component: component_11.ProfessionList,
        inMenu: true,
        acl: `${aclResources.onboarding}.${aclActions.read}`
    },
    {
        path: '/profession/form',
        name: 'route.profession.create'.t(),
        component: component_10.ProfessionForm,
        forceActive: '/profession/list',
        inMenu: false,
        acl: `${aclResources.onboarding}.${aclActions.write}`
    },
    {
        path: '/profession/form/:id',
        name: 'route.profession.edit'.t(),
        component: component_10.ProfessionForm,
        forceActive: '/profession/list',
        inMenu: false,
        acl: `${aclResources.onboarding}.${aclActions.write}`
    },
    {
        path: '/step/list',
        name: 'route.steps'.t(),
        component: component_13.StepList,
        inMenu: true,
        acl: `${aclResources.onboarding}.${aclActions.read}`
    },
    {
        path: '/step/form',
        name: 'route.step.create'.t(),
        component: component_12.StepForm,
        forceActive: '/step/list',
        inMenu: false,
        acl: `${aclResources.onboarding}.${aclActions.write}`
    },
    {
        path: '/step/form/:id',
        name: 'route.step.edit'.t(),
        component: component_12.StepForm,
        forceActive: '/step/list',
        inMenu: false,
        acl: `${aclResources.onboarding}.${aclActions.write}`
    },
];
